import React, { FC } from 'react';
import { Button, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FeedKey, UserFeedFollowGroupFragment } from 'api';
import { FollowToggle, PrivateGroupIcon, TableCellWithOverflow } from 'components';

import ImageCell from '../GroupCells/Image';
import TitleCell from '../GroupCells/Title';
import MembersCell from '../GroupCells/Members';
import theme from 'theme';

const styles = {
  row: {
    '&:nth-of-type(even)': {
      backgroundColor: 'common.white',
      border: `1px solid ${theme.palette.grey[300]}`,
    },
  },
  icon: {
    padding: `0, 1`,
  },
  actionButton: {
    width: 10,
  },
  greyButton: {
    color: 'grey.600',
  },
} as const;

interface Props {
  group: UserFeedFollowGroupFragment;
}

const RecommendedRow: FC<Props> = ({ group }) => {
  const { t } = useTranslation();

  const buttonClasses = (isFollowing: boolean) => ({
    ...styles.actionButton,
    ...(isFollowing && styles.greyButton),
  });

  function renderActionButton() {
    return (
      <FollowToggle source={group} type={FeedKey.Group}>
        {({ isFollowing, loading, onClick }) => (
          <Button
            color={isFollowing ? 'inherit' : 'primary'}
            variant="outlined"
            sx={{ root: buttonClasses(isFollowing) }}
            onClick={onClick}
            disabled={loading}
          >
            {t('common:join')}
          </Button>
        )}
      </FollowToggle>
    );
  }

  return (
    <TableRow sx={{ root: styles.row }} key={group.id}>
      <TableCell padding="none">
        <ImageCell group={group} />
      </TableCell>
      <TableCell sx={styles.icon} align="center">
        <PrivateGroupIcon group={group} type="index" />
      </TableCell>
      <TableCellWithOverflow padding="none">
        <TitleCell group={group} />
      </TableCellWithOverflow>
      <TableCell align="center">
        <MembersCell group={group} />
      </TableCell>
      <TableCell>{renderActionButton()}</TableCell>
    </TableRow>
  );
};

export default RecommendedRow;
